<template>
  <div class="d-flex flex-column align-items-center">
    <component
      v-if="!loaded_connections"
      :is="vue_select"
      :options="profile.networks" 
      label="network" 
      id="select-input-connection-proposal" 
      v-model="selected"
      multiple
      class="w-100 component-select-connections-proposal"
    >
    <template #no-options>
      <div >
        {{$t('creator.noOption')}}
      </div>
    </template>
      <template #selected-option="data">
        <div v-if="Object.keys(data).length > 1">
          <b-avatar class="mr-1" size="27" variant="ligth">
            <b-img :src="getIconWhite(data.network)" :class="getIconColor(data.network)" fluid></b-img>
          </b-avatar>
          <span>@{{(data.network === 'linkedin' ? data.name : data.username)}}</span>
        </div>
      </template>
      <template v-slot:option="data">
        <div class="option-submenu d-flex align-items-center">
            <b-avatar size="42" class="mr-1" variant="ligth">
              <b-img :src="getIconWhite(data.network)" :class="getIconColor(data.network)" fluid></b-img>
            </b-avatar>
            <div class="text-left">
              <span>{{capitalize(data.network)}}</span>
              <span class="d-block avenir-medium"> @{{(data.network === 'linkedin' ? data.name : data.username)}}</span>
            </div>
        </div>
      </template>
    </component>
    <b-skeleton type="input" v-else class="skeleton-input-connections"></b-skeleton>
    <b-link class="d-block my-2"  @click="show_sider_network = true">
      <feather-icon icon="PlusIcon"></feather-icon>  
      {{ $t('creator.connectOtherNetwork') }}
    </b-link>
    <sider-network 
      class="open-sidebar-search"
      @close_siderbar="closeSiderNetwork"
      @updated_network="updateNetworks"
      :show_sider_network="show_sider_network"
      v-if="show_sider_network"
      />
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BButton,
  BAvatar,
  BImg,
  BLink,
  BSkeleton,
} from 'bootstrap-vue';
import service_others from '@/services/others';
import { getIconWhite, getIconColor } from '@/libs/utils/icons'
import { capitalize } from '@/libs/utils/formats'
import { setuserData } from '@/libs/utils/user'

export default {
  name: 'enrichmentConnection',
  components: {
    BRow,
    BCol,
    BButton,
    BAvatar,
    BLink,
    BImg,
    BSkeleton,
    siderNetwork: () => import('@/views/pages/proposals/stepper/siderNetwork.vue'),
  },
  data() {
    return {
      capitalize,
      getIconWhite,
      getIconColor,
      show_sider_network: false,
      selected: [],
      profile: {
        networks: []
      },
      steps: null,
      index_actived: 0,
      selected_radio: null,
      vue_select: null,
      loaded_connections: false,
    }
  },
  props: {
    network_selected: {
      type: Array,
      default: () => [],
    },
    edit_by_agency: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    proposal() {
      return this.$route.params.proposal
    }
  },
  created() {
    if (this.edit_by_agency) {
      this.getProfileByVanityName()
    } else {
      this.getProfile()
    }
  },
  async mounted() {
    this.vue_select = (await import('vue-select')).default;
  },
  methods: {
    updateNetworks(profile) {
      this.profile.networks.unshift(profile)
    },
    closeSiderNetwork() {
      this.show_sider_network = false
    },
    getProfileByVanityName() {
      this.loaded_connections = true;
      service_others.getProfileByVanityName(this.$route.params.vanity_name).then((response) => {
        this.loaded_connections = false;
        this.profile = response.user;
        if (this.network_selected) {
          const selected = this.profile.networks.filter(item => this.network_selected.includes(item.uuid));
          this.selected = selected.length > 0 ? selected : [];
        }
      });
    },
    getProfile() {
      this.loaded_connections = true;
      const user = JSON.parse(localStorage.userData);
      service_others.getProfile().then((response) => {
        this.loaded_connections = false;
        this.profile = response.user;
        setuserData(response, user.ability);
        
        if (this.network_selected) {
          const selected = this.profile.networks.filter(item => this.network_selected.includes(item.uuid));
          this.selected = selected.length > 0 ? selected : [];
        }
      });
    },
  },
  watch: {
    selected(newValue) {
      this.$emit('selected_network', newValue.map(n => n.uuid))
    }
  }
}
</script>
<style scoped>
.skeleton-input-connections {
  height: 52.7px;
  width: 100%;
}
.icon-network-profile-connection {
  font-size: 24px;
  color: white;
}
.new-border {
  padding: 3px;
  border-radius: 100%;
}
</style>
<style>
.component-select-connections-proposal .vs__dropdown-toggle {
  background-color: white;
}
.vs--single .vs__dropdown-toggle {
  padding: 0.7em;
}
.vs__dropdown-option--selected {
  background:  #7367f0 !important;
  color: white !important;
}
</style>